import { COLORS } from '@alto/design-library-tokens';
import { AltoIcon, Column, Description, Row, XsSpacing, XxsSpacing } from '@alto/design-system';
import { DeliveryCardCTA } from '@alto/features';
import React from 'react';
import { formatShortAddress } from '~shared/helpers/address';
import { formatRelativeDateAndWindow } from '~shared/helpers/date';
import { type ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { type DeliveryDetails } from '~shared/types';

type Props = {
  readonly shipmentID: number;
  readonly origin?: (typeof ORIGIN_NAMES)[keyof typeof ORIGIN_NAMES];
  readonly deliveryDetails?: DeliveryDetails;
  readonly isEditable: boolean;
};

export const UpcomingDeliveryCard = ({ shipmentID, deliveryDetails, isEditable, origin }: Props) => {
  const renderDeliveryDetails = () => {
    if (deliveryDetails) {
      return (
        <>
          <XsSpacing />
          <Row>
            <AltoIcon
              name="calendar"
              accessibilityLabel="Calendar"
            />
            <XxsSpacing />
            <Description color={COLORS.TEXT_COLORS.GREY}>
              {formatRelativeDateAndWindow(deliveryDetails.date, deliveryDetails.startTime, deliveryDetails.endTime)}
            </Description>
          </Row>
          <XxsSpacing />
          <Row>
            <AltoIcon
              name="mapmarker"
              accessibilityLabel="Map marker"
            />
            <XxsSpacing />
            <Description color={COLORS.TEXT_COLORS.GREY}>{formatShortAddress(deliveryDetails.address)}</Description>
          </Row>
        </>
      );
    }
    return null;
  };

  return (
    <Column>
      {renderDeliveryDetails()}
      <DeliveryCardCTA
        origin={origin}
        isEditable={isEditable}
        deliveryDetails={deliveryDetails}
        shipmentID={shipmentID}
      />
    </Column>
  );
};
